// assets/stamped-data-fetcher.js

document.addEventListener('DOMContentLoaded', function() {
  // 1) Find and spinner‑seed every stamped placeholder
  var stampedEls = Array.from(document.querySelectorAll('[id^="stamped-"]'));
  stampedEls.forEach(function(el) {
    if (el.classList.contains('no-spinner')) return;
    
    el.classList.add('loading');
  });

  // 2) Grab the key placeholders
  var tierEl     = document.getElementById('stamped-rewards-viptier-placeholder');
  var discountEl = document.getElementById('stamped-rewards-viptier-discount-placeholder');
  var dynamicPercent = document.querySelector('.dynamic-percent');
  var descEl     = document.getElementById('stamped-rewards-description-placeholder');
  var statusLabelEl   = document.getElementById('stamped-status-label');


  if (!tierEl) return;

  // 3) Core logic: when tier text appears, clear spinners & write your fields
  function processCard() {
    var tierText = tierEl.textContent.trim();
    if (!tierText) return false;

    if (statusLabelEl) statusLabelEl.style.display = 'inline';


    // — clear spinner on every stampedEl —
    stampedEls.forEach(function(el) {
      el.classList.remove('loading');
    });

    // — description logic —
    if (descEl) {
      if      (tierText === "Silver") descEl.textContent = 
        "Spend $5,000 in one calendar year to advance to Gold status and earn 20% off all orders and 1.25X reward points.*";
      else if (tierText === "Gold")   descEl.textContent = 
        "Enjoy 1.25X the points with Gold status. Spend $20,000 in one calendar year to advance to Platinum status and earn 25% off all orders and 1.5X reward points.*";
      else                             descEl.textContent = 
        "As a Platinum trade member, you get 25% off and 1.5X the points.";
    }

    // — discount logic —
    if (discountEl) {
      discountEl.textContent = tierText === "Silver" ? "15% Off" :
                               tierText === "Gold"   ? "20% Off" : "25% Off";
    }

    if (dynamicPercent) {
      dynamicPercent.textContent = tierText === "Silver" ? "15" :
                               tierText === "Gold"   ? "20" : "25";
    }

    return true;
  }

  // 4) Try immediately (in case Stamped already wrote the tier)
  if (!processCard()) {
    // 5) Otherwise observe tierEl for its first mutation
    var obs = new MutationObserver(function(muts, o) {
      if (processCard()) o.disconnect();
    });
    obs.observe(tierEl, { childList: true, subtree: true, characterData: true });
  }
});

